import { z } from 'zod';
// ----------------------------------------------------------------------------
//  Response — mirrors @whyhotel/sales-api PropertyCodesResult (POST
//  /property-codes). A code carries an optional human label (the company name
//  for a corporate code); promo codes have only the code.
// ----------------------------------------------------------------------------
export const SalesCodeSchema = z.object({
    code: z.string(),
    label: z.string().optional()
});
export const PropertyCodesResultSchema = z.object({
    promoCodes: z.array(SalesCodeSchema),
    corporateCodes: z.array(SalesCodeSchema)
});
export const EMPTY_PROPERTY_CODES = {
    promoCodes: [],
    corporateCodes: []
};
// Collapses several properties' code lists into one deduped set, keeping
// first-seen order. A city/region search fans out one call per property (each
// list already deduped by the API); the same code shared across properties in a
// market must appear once. When a code repeats, keep the first suggestion that
// carries a label so corporate company names survive the merge.
const mergeByCode = (codes) => {
    const byKey = new Map();
    for (const suggestion of codes) {
        const key = suggestion.code.trim().toLowerCase();
        if (!key) {
            continue;
        }
        const existing = byKey.get(key);
        if (!existing) {
            byKey.set(key, suggestion);
        }
        else if (!existing.label && suggestion.label) {
            byKey.set(key, suggestion);
        }
    }
    return [...byKey.values()];
};
export const dedupeCodeSuggestions = (perProperty) => ({
    promoCodes: mergeByCode(perProperty.flatMap(codes => codes.promoCodes)),
    corporateCodes: mergeByCode(perProperty.flatMap(codes => codes.corporateCodes))
});
